<template>
  <Dialog :common-dialog="dialog" :dialog-width="dialogWidth">
    <template v-slot:title>
      <v-layout class="px-4">
        <v-flex> Select a Entity </v-flex>
        <v-flex class="text-right">
          <v-btn
            style="height: 32px !important"
            class="custom-bold-button"
            depressed
            icon
            :disabled="loading"
            v-on:click="$emit('close', true)"
            color="red white--text"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <div class="px-4 w-100">
        <label for="customer-search" class="font-weight-600"
          >Which entity would you like to select this for?</label
        >
        <div class="d-flex mb-2">
          <v-text-field
            id="customer-search"
            v-model="search"
            class="line-item-header-text px-0 v-slot-m-none"
            placeholder="Search Entity..."
            dense
            filled
            solo
            flat
            color="cyan"
            :loading="loading"
            :disabled="loading"
            style="max-width: 400px"
          />
          <v-btn
            v-on:click="getEntities()"
            :loading="loading"
            :disabled="loading"
            style="height: 32px !important"
            class="custom-bold-button ml-2"
            depressed
            color="cyan white--text"
            >Search</v-btn
          >
        </div>

        <div
          class="custom-border-top"
          style="max-height: calc(100vh - 300px); overflow-y: scroll"
        >
          <div v-if="list.length">
            <div
              v-for="(row, index) in list"
              :key="`customer-list-key-${index}`"
              class="cursor-pointer hover-grey d-flex align-center custom-border-bottom py-3 px-3"
              v-on:click="selectEntity(row)"
            >
              <div style="width: 80%">
                <p class="m-0 font-weight-500 font-size-16" v-if="false">
                  <Barcode :barcode="row.barcode" />
                </p>
                <p class="m-0 font-weight-500 font-size-16">
                  <v-icon class="chip-custom-blue mr-2" small
                    >mdi-office-building-outline</v-icon
                  >
                  <template v-if="row?.name">
                    {{ row.name }}
                  </template>
                </p>
                <p class="m-0 font-weight-500 font-size-16">
                  <v-icon class="chip-custom-blue mr-2" small
                    >mdi-map-marker-outline</v-icon
                  >
                  {{ row?.street_1 }}
                  {{ row?.unit_no }}
                  {{ row?.street_2 }}
                  {{ row?.landmark }}

                  <template v-if="row?.zip_code && row.zip_code != '000000'">
                    {{ row?.zip_code }}
                  </template>
                  <template v-if="row?.country">
                    {{ ", " + row?.country }}
                  </template>
                </p>
              </div>
              <!-- <div style="width: 20%">
                <p class="m-0 font-weight-500 font-size-16">
                  {{ row.property_count }} Site Location(s)
                </p>
                <p class="m-0 font-weight-500 font-size-16">
                  {{ row.persons_count }} Contact Person(s)
                </p>
              </div> -->
            </div>
          </div>
          <div
            v-else
            class="d-flex justify-center align-center py-3 font-weight-500"
          >
            <img
              width="40px"
              :src="$assetURL('media/error/empty.png')"
              class="row-not-found-image mr-2"
            />
            Uhh... There are no entity at the moment.
          </div>
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import Barcode from "@/view/pages/partials/Barcode.vue";
import { QUERY } from "@/core/services/store/request.module";
import {
  SET_ENTITY,
  SET_ENTITY_DIALOG,
  CLEAR_ENTITY,
} from "@/core/services/store/entity.module";
import ObjectPath from "object-path";
import {
  RESET_CREATE_STATE,
  RESET_STATE,
} from "@/core/services/store/visit.module";
import { CLEAR_CUSTOMER } from "@/core/services/store/customer.module";

export default {
  name: "select-customer",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog_key: 0,
      loading: false,
      search: null,
      list: [],
    };
  },
  watch: {
    dialog(param) {
      if (param) {
        this.search = null;
        this.getEntities();
      }
    },
  },
  components: {
    Dialog,
    Barcode,
  },
  methods: {
    selectEntity(row) {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      this.$store
        .dispatch(SET_ENTITY, row)
        .then(() => {
          this.search = null;
          this.list = [];
          this.$store.dispatch(CLEAR_CUSTOMER);
          this.$store.dispatch(RESET_CREATE_STATE);
          this.$store.dispatch(RESET_STATE);
          this.$emit("close", true);
          this.$emit("sucess", true);
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getEntities() {
      this.loading = true;
      this.list = [];
      this.$store
        .dispatch(QUERY, {
          url: "entity-list",
          data: { search: this.search },
        })
        .then((response) => {
          this.list = ObjectPath.get(response, "data", []);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    beforeDestroy() {
      this.$store.dispatch(CLEAR_ENTITY);
    },
    beforeMount() {
      this.$store.dispatch(CLEAR_ENTITY);
    },
    beforeCreate() {
      this.$store.dispatch(CLEAR_ENTITY);
    },
    closeEntityDialog() {
      this.$store.commit(SET_ENTITY_DIALOG, false);
    },
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
    /*  ...mapGetters([
      "reCustomerDialog",
     
    ]), */
  },
};
</script>
